/**
 * GW-6716: Global Token Purchase Modal
 *
 * Driven by the org tokens Zustand slice so any part of the app can trigger it
 * via openTokenPurchaseModal() without prop-drilling or local state.
 */

import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@gw/ui';
import { useNavigate } from 'react-router-dom';

import { useOrganizationTokensStore } from '@/stores/store';

export function TokenPurchaseModal() {
  const { showTokenPurchaseModal, closeTokenPurchaseModal } = useOrganizationTokensStore();
  const navigate = useNavigate();

  function handlePurchase() {
    closeTokenPurchaseModal();
    navigate('/organization/tokens');
  }

  return (
    <Dialog
      open={showTokenPurchaseModal}
      onOpenChange={(open) => {
        if (!open) closeTokenPurchaseModal();
      }}
    >
      <DialogContent data-testid="token-purchase-modal">
        <DialogHeader>
          <DialogTitle>Insufficient Token Balance</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-muted-foreground">
            Your organization needs additional tokens to continue. Purchase tokens to proceed.
          </p>
          <div className="flex justify-end space-x-2">
            <Button
              variant="outline"
              onClick={closeTokenPurchaseModal}
              data-testid="modal-close-button"
            >
              Cancel
            </Button>
            <Button onClick={handlePurchase} data-testid="purchase-success-continue">
              Purchase Tokens
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
